import { styled } from '@mui/material';

export const ForwardFriendWrapper = styled('section')(() => ({
  borderRadius: '0.5rem',
  marginTop: '1.5rem',
}));